import jwtDecode from "jwt-decode";

// Distinguishes a Bifrost (UMS) access token from a legacy auth token so we can
// route Bifrost tokens to UMS and keep old-app webview traffic on the legacy
// path. Accepts an optional "Bearer " prefix.
//
// Primary signal: Bifrost tokens are issued by Ory Hydra and carry a client_id of
// the form "client_xxx" — true on both stage and prod, so it is environment
// independent (unlike the issuer host, which differs: auth-service-stage.* vs
// auth.cars24.com). Legacy tokens have no such client_id and instead carry an
// isGuestLogin claim. The issuer check is kept only as a secondary fallback.
const isBifrostToken = (rawToken = "") => {
    try {
        const decoded = jwtDecode(String(rawToken).replace(/^Bearer\s+/i, ""));
        if (decoded?.isGuestLogin !== undefined) {
            return false; // legacy token
        }
        const clientId = typeof decoded?.client_id === "string" ? decoded.client_id : "";
        const issuer = typeof decoded?.iss === "string" ? decoded.iss : "";
        return clientId.startsWith("client_") || issuer.includes("auth-service");
    } catch (e) {
        return false;
    }
};

// Detects old AU auth tokens by their issuer URL.
// These tokens were issued by the legacy user-authentication-service-au and need
// to be exchanged for Bifrost tokens via the au_to_client exchange flow.
export const isOldAuToken = (rawToken = "") => {
    try {
        const decoded = jwtDecode(String(rawToken).replace(/^Bearer\s+/i, ""));
        const issuer = typeof decoded?.iss === "string" ? decoded.iss : "";
        return issuer.includes("user-authentication-service-au");
    } catch (e) {
        return false;
    }
};

export default isBifrostToken;
